import { Address as ResponseAddress } from "@/Common/Api/Contacts/Dto/Address";
import { ValidationRule } from "@/Common/Api/Validation/Dto/Responses/ValidationRule";
import { ValidationHelper } from "@/Common/Helpers/ValidationHelper";

class Address {
    public validationHelper: ValidationHelper;
    public validationRule: ValidationRule;

    public StreetAddress: string = "";
    public City: string = "";
    public ZipCode: string = "";
    public CustomCountryOrProvince: string = "";
    public Country: string = "";
    public CountryLookupId: string = "";
    public StateLookupId: string = "";
    public State: string = "";
    public AddressType: string = "";
    public IsPreferred: boolean;
    public ContactPoint_id: string;
    public SiteId: string;

    constructor(init?: Partial<Address>) {
        Object.assign(this, init);
        this.validationHelper = new ValidationHelper();
    }

    public GetFormatedPostalCode(): string {
        // get validation info
        var displayFormatSelector: string = this.validationRule ? this.validationRule.DisplayFormatSelectorPatern : "";
        var displayFormatSubstitution: string = this.validationRule ? this.validationRule.DisplayFormatSubstitution : "";
        var result = this.validationHelper.getFormatedString(this.ZipCode, displayFormatSelector, displayFormatSubstitution);

        return result;
    }

    public static FromResponseModel(response: ResponseAddress): Address {
        const address = new Address({
            City: response.City,
            ZipCode: response.ZipCode,
            CountryLookupId: response.CountryLookupId,
            Country: cacheStore.GetLocalizedValueByLookupId(response.CountryLookupId),
            State: cacheStore.GetLocalizedValueByLookupId(response.StateLookupId),
            StateLookupId: response.StateLookupId,
            StreetAddress: response.StreetAddress,
            IsPreferred: response.IsPreferred,
            ContactPoint_id: response.ContactPoint_id
        });

        address.validationRule = address.validationHelper.getPostalCodeValidationRule(address.CountryLookupId, null);

        return address;
    }
}

export { Address };
